import {FC} from 'react'
import ReactMarkdown from 'react-markdown'

const INK = '#1b1b29'
const MUTED = '#475569'
const ACCENT = '#039540'

/** Brand-styled Markdown renderer (safe — no raw HTML). */
export const Markdown: FC<{children: string}> = ({children}) => (
  <div style={{color: MUTED, fontSize: 15, lineHeight: 1.7}}>
    <ReactMarkdown
      components={{
        h1: ({children}) => <h1 style={{fontSize: 26, fontWeight: 800, color: INK, margin: '0 0 14px'}}>{children}</h1>,
        h2: ({children}) => <h2 style={{fontSize: 20, fontWeight: 800, color: INK, margin: '26px 0 10px'}}>{children}</h2>,
        h3: ({children}) => <h3 style={{fontSize: 16, fontWeight: 700, color: INK, margin: '20px 0 8px'}}>{children}</h3>,
        p: ({children}) => <p style={{margin: '0 0 14px'}}>{children}</p>,
        ul: ({children}) => <ul style={{margin: '0 0 14px', paddingLeft: 22}}>{children}</ul>,
        ol: ({children}) => <ol style={{margin: '0 0 14px', paddingLeft: 22}}>{children}</ol>,
        li: ({children}) => <li style={{margin: '4px 0'}}>{children}</li>,
        strong: ({children}) => <strong style={{color: INK, fontWeight: 700}}>{children}</strong>,
        a: ({children, href}) => <a href={href} style={{color: ACCENT, fontWeight: 600, textDecoration: 'none'}}>{children}</a>,
        blockquote: ({children}) => <blockquote style={{margin: '0 0 14px', padding: '10px 16px', borderLeft: `3px solid ${ACCENT}`, background: '#f8fafc', borderRadius: 8, color: INK}}>{children}</blockquote>,
        code: ({children}) => <code style={{background: '#f1f3f7', borderRadius: 6, padding: '2px 6px', fontSize: 13.5, color: INK}}>{children}</code>,
        hr: () => <hr style={{border: 'none', borderTop: '1px solid #eef0f4', margin: '20px 0'}} />,
      }}
    >
      {children}
    </ReactMarkdown>
  </div>
)
